import { VALIDATION_MESSAGE_TYPES as e } from "../constants/index.js";
//#region common/validators/index.js
function t(t) {
	return t ? t.every((t) => typeof t == "string" ? !0 : typeof t == "object" ? Object.values(e).includes(t?.type) : !1) : !0;
}
function n(e) {
	let t = Array.isArray(e) ? e.map(String) : Object.keys(e);
	return (e) => t.includes(String(e));
}
var r = {
	validationMessageValidator: t,
	ordinalSizeValidator: n
};
//#endregion
export { r as default, n as ordinalSizeValidator, t as validationMessageValidator };

//# sourceMappingURL=index.js.map